import styled from 'styled-components'

import theme from 'theme_'
import { WhiteBlock } from 'components/Layout'

export const SpinnerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: ${theme.spacing.md};
`

export const ConnectedAppsContentContainer = styled(WhiteBlock)`
  position: relative;
  z-index: 1;
  flex-basis: 100%;
`
